<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="推送/代投统计">
        <div class="row align--center mb-1">
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter(null)">总用户: {{allCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter(3)">basic付费用户: {{basicChargeCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter(1)">pro付费用户: {{proChargeCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter(2)">学员: {{xueYuanCount}}</va-button>
          </div>
        </div>

        <div class="flex md4 xs12">
          <va-input
            class="ma-0"
            :value="keyword"
            placeholder="按用户名或邮箱搜索"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend"/>
          </va-input>
        </div>

        <va-data-table
          :fields="fields"
          :data="jobUsers"
          :loading="loading"
          :totalPages="totalPage"
          @page-selected="listJobUser"
          api-mode
        >
          <template slot="typeSlot" slot-scope="props">
            <va-badge :color="computeStatus(props.rowData.type, props.rowData.renewStatus, props.rowData.subscriptionVersion).color">
              {{ computeStatus(props.rowData.type, props.rowData.renewStatus, props.rowData.subscriptionVersion).text }}
            </va-badge>
          </template>
          <template slot="lastPushTime" slot-scope="props">
            {{ formatPushTime(props.rowData.lastPushTime) }}
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看趋势" placement="top">
              <va-button flat small color="gray" icon="fa fa-line-chart"
                :to='{path:`pushDeliverStats/${props.rowData.uid}`}'/>
            </va-popover>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>

import { formatTime } from '@/utils/common'
import openJobApi from '../../api/openJob'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      jobUsers: [],
      loading: true,
      basicChargeCount: 0,
      proChargeCount: 0,
      xueYuanCount: 0,
      allCount: 0,
      totalPage: null,
      keyword: null,
      currentSubscriptionStatus: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'nickname',
          title: '用户名',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '18%',
        },
        {
          name: 'email',
          title: '邮箱',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '28%',
        },
        {
          name: '__slot:typeSlot',
          title: '订阅状态',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '20%',
        },
        {
          name: '__slot:lastPushTime',
          title: '最近推送时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '20%',
        },
        {
          name: '__slot:actions',
          title: '操作',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '14%',
        },
      ]
    },
  },
  created () {
    this.listJobUser()
  },
  methods: {
    search: debounce(function (keyword) {
      this.keyword = keyword
      if (this.keyword === '') { this.keyword = null }
      this.listJobUser(1)
    }, 400),
    applyFilter (subscriptionStatus) {
      this.currentSubscriptionStatus = subscriptionStatus
      this.listJobUser(1)
    },
    listJobUser (pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 100,
        pageNumber: pageNumber,
        keyword: this.keyword,
        subscriptionStatus: this.currentSubscriptionStatus,
      }
      openJobApi.listUser(data)
        .then(response => {
          this.jobUsers = response.userSimpleInfoList
          this.totalPage = response.totalPage
          this.basicChargeCount = response.basicChargeCount
          this.proChargeCount = response.proChargeCount
          this.xueYuanCount = response.xueYuanCount
          this.allCount = response.allCount
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    /**
     * 订阅状态徽章颜色 + 文案，与 listUser.vue 的 computeStatus 保持一致。
     */
    computeStatus (type, renewStatus, version) {
      const data = { color: 'success', text: '免费' }
      const versionTag = version === 'new' ? '(新版)' : version === 'old' ? '(旧版)' : ''
      const renewTag = renewStatus === 0 ? '(到期不续费)' : ''

      if (type === 1 || type === 7) {
        data.color = 'danger'
        data.text = '付费pro' + versionTag + renewTag
      } else if (type === 3 || type === 6) {
        data.color = 'danger'
        data.text = '付费basic' + versionTag + renewTag
      } else if (type === 8) {
        data.color = 'danger'
        data.text = '付费autopilot' + versionTag + renewTag
      } else if (type === 4 || type === 10) {
        data.color = 'danger'
        data.text = '付费pro(试用期)' + versionTag
      } else if (type === 5 || type === 9) {
        data.color = 'danger'
        data.text = '付费basic(试用期)' + versionTag
      } else if (type === 11) {
        data.color = 'danger'
        data.text = '付费autopilot(试用期)' + versionTag
      } else if (type === 2) {
        data.color = 'warning'
        data.text = '学员'
      } else if (type === -1) {
        data.color = 'info'
        data.text = '未提交问卷'
      } else if (type === -2) {
        data.color = '#ff8c00'
        data.text = '试用期取消'
      } else if (type === -3) {
        data.color = '#9932CC'
        data.text = '不续费取消'
      }
      return data
    },
    formatPushTime (time) {
      if (!time) {
        return '-'
      }
      return formatTime(time)
    },
  },
}
</script>
